import { FC } from 'react';

import LanguageSwitcher from './LanguageSwitcher';
import './index.scss';

import { ReactComponent as Logo } from '../../../assets/images/logo.svg';
import { getConfig, isStandaloneMode } from '../../../config';

const Header: FC = () => {
    if (!isStandaloneMode) {
        return null;
    }

    return (
        <header className="pf-header">
            <a href={getConfig('homeUrl')} className="pf-header__logo">
                <Logo />
            </a>
            <LanguageSwitcher />
        </header>
    );
};

export default Header;
